/*
 * @创建人: 但志强
 * @修改人: 但志强
 * @描述: 文件预览服务
 * @创建时间: 2019-08-28 09:59:23
 * @修改时间: 2019-08-28 10:04:42
 */

import { Injectable, Injector, ApplicationRef, ComponentFactoryResolver } from '@angular/core';
import { SwViewFileComponent } from '../../components/basic-components/sw-view-file/sw-view-file.component';
import { SwHttpClientService } from '../sw-http-client.service';
import { environment } from 'src/environments/environment';
import { SwMassageBoxService } from '../sw-massage-box.service';
import { SwPhotoAlbumService } from '../../components/basic-components/sw-photo-album/sw-photo-album.service';
import { GetSuffixImgService } from './get-suffix-img.service';

@Injectable({
  providedIn: 'root'
})
export class SwViewFileService {

  constructor(  
    private injector: Injector,
    private applicationRef: ApplicationRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private http:SwHttpClientService,
    private box:SwMassageBoxService,
    public popup: SwPhotoAlbumService ,
    private getSuffixImgService:GetSuffixImgService  ) { }

     /**
   * @ignore
   * 文件处理微服务api
   */
  fileUrl :string = environment.fileWebAPI

  private swViewFileComponentRef:any;

  /**
   * 预览文件
   * @param path  文件路径(environment.staticFileUrl + file.filePath + file.fileName)
   * @param serverPath  文件服务器路径(file.serverPath +file.filePath+file.fileName)--判断该文件是否已经可以预览
   * @param file  传入的要预览的文件
   * @param fileList  传入的要预览文件数组,如果要预览的文件是图片,且数组中有其他图片,就一起预览
   */
  viewFile(path:string,serverPath?:string,file?:any,fileList?:any[]){
    //先根据后缀分辨文件类型
    let suffix = path.substring(path.lastIndexOf('.')+1)
    if(suffix){
      let url = this.getSuffixImgService.getFileTypeImg(suffix)
      if(url == 'assets/Images/files/img.png'){
        //如果是图片，看 fileList 数组是否存在多个图片
        if(file && fileList){
          //如果传入了文件和文件列表,说明想要预览多个图片
          let fileSuffix = file.fileSuffix.toLocaleLowerCase()
          if(fileSuffix == 'jpg' || fileSuffix == 'jpeg' || fileSuffix == 'png' || fileSuffix == 'bmp' || fileSuffix == 'gif'){
            //如果要预览的是图片,就看数组中是否有其他图片
            let viewList = fileList.filter(item=>item.fileSuffix.toLocaleLowerCase() =='jpg' || item.fileSuffix.toLocaleLowerCase() =='jpeg' || item.fileSuffix.toLocaleLowerCase() =='png' || item.fileSuffix.toLocaleLowerCase() =='bmp' || item.fileSuffix.toLocaleLowerCase() =='gif')
            let index
            let pathArr = []
            viewList.forEach((item,i)=>{
              pathArr.push(environment.staticFileUrl+item.filePath+item.fileName)
              if(item.fileInfoId == file.fileInfoId){
                index = i
              }
            })
            let photosData = {path:pathArr,index:index};
            this.popup.showPhotoAlbum(photosData)
      
          }
        } else {
          //如果只有路径，没有文件列表，说明只想预览单个图片
          let photosData = {path:[path],index:0};
          this.popup.showPhotoAlbum(photosData)
        }
      } else if(url == 'assets/Images/files/doc.png' || url == 'assets/Images/files/xls.png' || url == 'assets/Images/files/pdf.png' || url == 'assets/Images/files/audio.png' || url == 'assets/Images/files/video.png' || url == 'assets/Images/files/txt.png'){
        // 如果是预览文档，Excel，pdf，音频，视频，文本
        //根据文件名获取文件信息
        let fileSuffix = path.split('/');  //文件名不会包含 '/' 这个符号,可以确定最后一个元素就是文件名
        let fileName = fileSuffix[fileSuffix.length-1]
        //根据文件名可以查询到位移的文件信息
        let datas = {
          fileName:fileName
        }
        let type = 1
        if(url == 'assets/Images/files/doc.png' || url == 'assets/Images/files/xls.png' || url == 'assets/Images/files/pdf.png'|| url == 'assets/Images/files/txt.png'){
          type = 1
        } else if(url == 'assets/Images/files/audio.png'){
          type = 2
        } else if(url == 'assets/Images/files/video.png'){
          type = 3
        }
        this.http.Post(this.fileUrl + "fileInfo/queryPageList" , datas).subscribe(res=>{
          if(res && res.code == 200 && res.data.records.length){
            //查询结果存在
            let fileObj = res.data.records[0]
            serverPath = serverPath || (fileObj.serverPath +fileObj.filePath+fileObj.fileName)
            //根据 serverPath 判断是否可以预览
            //先修改文件的后缀类型,将doc 改成pdf,将xslx改成html
            let newServerPath = this.fileSuffixConversion(serverPath)
            //判断该文件后台是否已经处理好,是否可以进行预览
            this.http.Post(environment.fileWebAPI+'fileInfo/checkFileExist?filePath='+newServerPath,{}).subscribe(res=>{
              //如果已经处理好了,就进行预览
              if(res.data == 1){
                const com = document.createElement(SwViewFileComponent.name);
                // //创建动态组件
                const factory = this.componentFactoryResolver.resolveComponentFactory(SwViewFileComponent);
                this. swViewFileComponentRef = factory.create(this.injector, [], com);
                this.applicationRef.attachView(this.swViewFileComponentRef.hostView);
                this. swViewFileComponentRef.instance["src"] =path;
                this. swViewFileComponentRef.instance["type"] =type;
                this. swViewFileComponentRef.instance["fileName"] =fileObj.fileOldname;
                this. swViewFileComponentRef.instance["callback"].subscribe(data => {
                  try {
                    document.body.removeChild(com);
                    this.applicationRef.detachView(this.swViewFileComponentRef.hostView);
                    this.swViewFileComponentRef.destroy()
                  } catch (e) { }
                });
                document.body.appendChild(com);
              } else if(res.data == 0){
                //如果还没有处理好,就提示
                this.box.danger("文件不存在或未处理完成")
              }
            })
          } else{
            //文件查询失败,还是要创建文件预览组件
            if(serverPath){  //如果有判断条件就判断,没有就不判断
              let newServerPath = this.fileSuffixConversion(serverPath)
              //判断该文件后台是否已经处理好,是否可以进行预览
              this.http.Post(environment.fileWebAPI+'fileInfo/checkFileExist?filePath='+newServerPath,{}).subscribe(res=>{
                //如果已经处理好了,就进行预览
                if(res.data == 1){
                  const com = document.createElement(SwViewFileComponent.name);
                  // //创建动态组件
                  const factory = this.componentFactoryResolver.resolveComponentFactory(SwViewFileComponent);
                  this. swViewFileComponentRef = factory.create(this.injector, [], com);
                  this.applicationRef.attachView(this.swViewFileComponentRef.hostView);
                  this. swViewFileComponentRef.instance["src"] =path;
                  this. swViewFileComponentRef.instance["type"] =type;
                  this. swViewFileComponentRef.instance["fileName"] = "";
                  this. swViewFileComponentRef.instance["callback"].subscribe(data => {
                    try {
                      document.body.removeChild(com);
                      this.applicationRef.detachView(this.swViewFileComponentRef.hostView);
                      this.swViewFileComponentRef.destroy()
                    } catch (e) { }
                  });
                  document.body.appendChild(com);
                } else if(res.data == 0){
                  //如果还没有处理好,就提示
                  this.box.danger("文件不存在或未处理完成")
                }
              })
            } else {  //没有判断条件就不判断
              const com = document.createElement(SwViewFileComponent.name);
              // //创建动态组件
              const factory = this.componentFactoryResolver.resolveComponentFactory(SwViewFileComponent);
              this. swViewFileComponentRef = factory.create(this.injector, [], com);
              this.applicationRef.attachView(this.swViewFileComponentRef.hostView);
              this. swViewFileComponentRef.instance["src"] =path;
              this. swViewFileComponentRef.instance["fileName"] ="";
              this. swViewFileComponentRef.instance["callback"].subscribe(data => {
                try {
                  document.body.removeChild(com);
                  this.applicationRef.detachView(this.swViewFileComponentRef.hostView);
                  this.swViewFileComponentRef.destroy()
                } catch (e) { }
              });
              document.body.appendChild(com);
              this.box.danger("文件查询失败或文件不存在")
            }
          }
        })
      } else if(url == 'assets/Images/files/zip.png' || url == 'assets/Images/files/null.png'){
        //如果是压缩包或位置类型文件，就提示，该类型的文件不支持预览
        this.box.danger("该类型的文件不支持预览")
      }
    }
  }

  /**
   * 转化文件后缀
   * 将doc 改成pdf
   * 将xslx改成html
   */
  fileSuffixConversion(filePath){
    let fileSuffix = filePath.split('.');
    switch(fileSuffix[fileSuffix.length-1].toLocaleLowerCase()){
      case "docx" : fileSuffix[fileSuffix.length-1] = "pdf";  break;
      case "doc"  : fileSuffix[fileSuffix.length-1] = "pdf"; break;
      case "xls"  : fileSuffix[fileSuffix.length-1] = "html";break;
      case "xlsx" : fileSuffix[fileSuffix.length-1] = "html";  break;
    }
    let url ="";
    fileSuffix.forEach(path => {
      url +=path+"."
    });
    return url.substring(0,url.length-1)
  }
}
